<template>
  <div class="year">
    <div>{{year}}</div>
    <div class="months">
      <div class="month" v-for="({ endDay, month, startWdy }, m) in monthEnd" :key="m"
      :class="[thisYear===year&&m<thisMonthNum?'pass':'', thisYear===year&&m<(parseInt(thisMonthNum/3)*3)?'hidden':'']">
        <div class="month-title">{{month}}</div>
        <div class="days">
          <div class="d wd" v-for="(d) in wdy" :key="`wdy-${m}-${d}`">{{d}}</div>
          <div class="d empty" v-for="(d) in startWdy" :key="`empty-${m}-${d}`"></div>
          <div class="d day"
          v-for="(d) in endDay" :key="`${m}-${d}`" :disabled="!edit||moment(`${year}-${m+1}-${d}`, 'yyyy-M-D').isBefore(today)"
          @click="$emit(holidays.includes(moment(`${year}-${m+1}-${d}`, 'yyyy-M-D').format('yyyy-MM-DD'))?'pull':'push', moment(`${year}-${m+1}-${d}`, 'yyyy-M-D').format('yyyy-MM-DD'))"
          :class="[
            holidays.includes(moment(`${year}-${m+1}-${d}`, 'yyyy-M-D').format('yyyy-MM-DD'))?'holiday':'',
            moment(`${year}-${m+1}-${d}`, 'yyyy-M-D').isBefore(today)?'pass':''
        ]"
          :id="moment(`${year}-${m+1}-${d}`, 'yyyy-M-D').format('yyyy-MM-DD')">{{d}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['year', 'holidays', 'edit'],
  data () {
    return {
      wdy: ['日', '一', '二', '三', '四', '五', '六'],
      today: this.moment(),
      thisMonthNum: this.moment().month(),
      thisYear: this.moment().year()
    }
  },
  computed: {
    monthEnd () {
      return Array(12).fill('1').map((e, i) => {
        return {
          startWdy: this.moment().year(this.year).month(i).startOf('month').weekday(),
          month: this.moment().year(this.year).month(i).format('MMM'),
          endDay: parseInt(this.moment().year(this.year).month(i).endOf('month').format('D'))
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.year {
  padding: 10px;
}
.year > div:nth-child(1){
  text-align: center;
  height: 60px;
  color: var(--color-pri);
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.months {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.month {
  border: 1px solid #CACACA;
  .month-title {
    text-align: center;
  }
  &.hidden {
    display: none;
  }
}
.d {
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  text-align: center;
  line-height: 36px;
  &:nth-of-type(7n) {
    background-color: #eaeaea;
  }
  &:nth-of-type(7n+1) {
    background-color: #eaeaea;
  }
  &.wd {

  &:nth-of-type(7n) {
    background-color: transparent;
  }
  &:nth-of-type(7n+1) {
    background-color: transparent;
  }
  }
  &.holiday {
    background-color: var(--color-checked);
    color: #FFFFFF;
    border-radius: 20px;
    max-width: 36px;
    max-height: 36px;
    align-self: center;
  }
  &.pass {
    background-color: #eaeaea;
  }
}
.days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0;
}
.empty {
  color: #CACACA;
}
</style>
